








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { IncomeCategoryDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxIncomeCategory extends Vue {
  private types: IncomeCategoryDto[] | null = [];
  public selectedType = new IncomeCategoryDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: IncomeCategoryDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: IncomeCategoryDto) {
    this.$emit("incomeCategorySelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .incomeCategory_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
